import { render, staticRenderFns } from "./CDEKModule.vue?vue&type=template&id=f3cc4a0c"
import script from "./CDEKModule.vue?vue&type=script&lang=js"
export * from "./CDEKModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports